import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { AllProductDetailsQuery } from "../../lib/graphQL/graphQuery";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function ProductListTable() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [productData, setProductData] = useState([]);
 
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  useEffect(() => {
    fetchProductData();
    setStatus(false);
  }, [id, status]);

  //Fetch Table Data
  const fetchProductData = () => {
    setIsLoading(true);
    request(BASEURL, AllProductDetailsQuery, { id: currentUser?.id })
      .then((res) => {
        setProductData(res.allProduct);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //Table Mapping
  const productListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Product ID",
        field: "productid",
        name: "Product ID",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Product Name",
        field: "productName",
        name: "Product Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Category",
        field: "categoryName",
        name: "Category",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Brand",
        field: "brandName",
        name: "Brand",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Product Cost",
        field: "productCost",
        name: "Product Cost",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: productData.reverse().map(
      (item, index) => (
        {
          sno: index + 1,
          id: item.id,
          productid: item.productid,
          productName: item.productName,
          categoryName: item.category.categoryName,
          brandName: item.brand.brandName,
          productCost: item.productCost,
          createdBy: item.user.username,
          createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
        }
      )
    ),
  };

  //Add Product Button
  const handleNewProduct = () => {
    navigate("/product/add-product");
  };

  //Row Click
  const onProductListClick = (e) => {
    const editProductData = productData.find((item) => item?.id === e?.id);
    if (e?.id) {
      navigate(`/product/add-product?${e?.id}`);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
    const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }


  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={productListTable.columns}
      rowsData={productListTable.rows}
      head="Product List"
      actions={true}
      checked={false}
      view={true}
      onCheck={onCheck}
      showAdd = {true}
      onEdit={onProductListClick}
      // onDelete={onDelete}
      onView={onProductListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewProduct()}
      
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Product List 
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewProduct()}
              >
                Add Product
              </MaterialButton>
            </Stack>
          }
        />
        { !isLoading &&
        <MaterialDataGrid
          rows={productListTable.rows}
          columns={productListTable.columns}
          isSelectable={false}
          onRowClick={onProductListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Product found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any Product details. Click on the "Add
                  Product" button to start adding Product details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />}
             {isLoading && <PageLoading />}
        
      </Card> */}
    </DashboardLayout>
  );
}
